/**
 * currently we directly put reducing fall risk exercises to be static sources
 */

import React from 'react';

import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import ExerciseView from '../../components/fpp/ExerciseView';

import straightLegRaise from '../../styles/images/fppExercises/straightLegRaise.png';
import heelSlide from '../../styles/images/fppExercises/heelSlide.png';
import elbowFlexion from '../../styles/images/fppExercises/elbowFlexion.png';
import shoulderFlexion from '../../styles/images/fppExercises/shoulderFlexion.png';
import shoulderPresses from '../../styles/images/fppExercises/shoulderPresses.png';
import hipAdbuction from '../../styles/images/fppExercises/hipAdbuction.png';
import marchingInPlace from '../../styles/images/fppExercises/marchingInPlace.png';
import standingHipAdbuction from '../../styles/images/fppExercises/standingHipAdbuction.png';
import toeRaises from '../../styles/images/fppExercises/toeRaises.png';
import standingLegExtension from '../../styles/images/fppExercises/standingLegExtension.png';

const ExerciseContainer = () => {
  const exercises = [
    {
      title: 'Straight Leg Raise',
      description: 'Total leg workout that will assist with walking, transferring and especially with getting in and out of bed. Works muscles in the stomach and back.',
      steps: ['Lieonbed,straightenrightlegandplaceleftfootflat.', 'Raise right leg with knee locked.', 'Lowerrightlegslowlyanddonotallowtogoallthewaydown to bed.', 'Complete a set of 10 leg raises with one leg, then repeat with the other leg.'],
      img: straightLegRaise,
      id: '1',
    },
    {
      title: 'Heel Slide',
      description: 'Increase leg strength to help with walking, transfers and stairs.',
      steps: ['Bend right knee and pull heel towards buttocks.', 'Slowly straighten knee.', 'Go slow.', 'Complete a set with one leg then repeat with  the other leg.'],
      img: heelSlide,
      id: '2',
    },
    {
      title: 'Elbow Flexion (Can use light weights)',
      description: 'Assists with all daily activities.',
      steps: ['Turn palms up so facing ceiling.', 'Keeping upperarmsonbedslowlybendBOTHelbows.', 'Slowly straighten arm.', 'Repeat 10 times.'],
      img: elbowFlexion,
      id: '3',
    },
    {
      title: 'Shoulder Flexion (Can use light weights)',
      description: 'Increases arm strength with dressing, cleaning, cooking and reaching for objects overhead.',
      steps: ['Point thumb towards ceiling.', 'Slowly lift right arm over your head keeping elbow straight.', 'Bring it back down to your side.', 'Liftarmupoveryourheadandbackdown.', 'Go slow in both directions.', 'Repeat 10 times with each arm.'],
      img: shoulderFlexion,
      id: '4',
    },
    {
      title: 'Shoulder Presses (Can use light weights)',
      description: 'Total arm workout that will help with all daily activities.',
      steps: ['Holdarmsuptowardstheceilingwith elbows straight.', 'Bring hands down and touch your chest,keeping elbows pointed away from body.', 'Now slowly straighten arms.', 'BREATHE.Goslowly.', 'Repeat 10 times.'],
      img: shoulderPresses,
      id: '5',
    },
    {
      title: 'Hip Abduction',
      description: 'Strengthens hip stabilizers which will help improve balance.',
      steps: ['Slide right leg out to the side.', 'Keep kneecap pointing toward ceiling.', 'Slowly bring leg back to middle.', 'Make sure leg barely lifts off bed.', 'Complete a set of 10 with one leg then repeat with the other leg.'],
      img: hipAdbuction,
      id: '6',
    },
    {
      title: 'Marching in Place',
      description: 'Teaches weight shifting and standing on one foot.',
      steps: ['Rest hands on chair.', 'Keeping back as straight as possible, lift right knee up towards your chest and hold for a moment.', 'Slowly lower right leg.', 'Keeping back as straight as possible, lift left knee up towards your chest and hold for a moment.', 'Slowly lower left leg.', 'Repeat 10 times.'],
      img: marchingInPlace,
      id: '7',
    },
    {
      title: 'Standing Hip Abduction',
      description: 'Strengthens hip stabilizers that assist with walking.',
      steps: ['Rest hands on chair.', 'Kick leg out to side, keeping knee straight and toes pointed forward.', 'Make sure the kick movements are side to side and not to the front or back.', 'It should be a small movement.', 'Do not let leg drop back to starting position, control its descent.', 'Repeat 10 times with each leg.'],
      img: standingHipAdbuction,
      id: '8',
    },
    {
      title: 'Toe Raises',
      description: 'Most older adults are fearful of falling forward so they push backwards. This exercise helps them feel more comfortable leaning backward. Strengthens backs of legs which will assist with balance. The goal is to complete the exercise safely without any support on the chair.',
      steps: ['Rest hands on chair, use legs for balance, not arms.', 'Go up and down on toes.', 'Go slowly.', 'Do not lean forward.', 'Repeat 10 times.'],
      img: toeRaises,
      id: '9',
    },
    {
      title: 'Standing Leg Extension',
      description: 'This strengthens the muscles in the backofthelegandincreasesconfidencewithstepping backwards.',
      steps: ['Rest hands on chair.', 'Slowly kick left leg back, keeping knee straight.', 'It should be a small movement. If you start to lean forward you are kicking too far.', 'Do not let leg drop back to starting position, control its descent.', 'Repeat 10 times with each leg.'],
      img: standingLegExtension,
      id: '10',
    },
  ];
  return (
    <ExerciseView
      list={exercises}
    />
  );
};

export default connectActionsAndReducers(ExerciseContainer);



// WEBPACK FOOTER //
// ./src/containers/fpp/ExerciseContainer.js